import * as constants from './constants';
import { createReducer } from '../../utils';
import initialState from './initialstate';

export default createReducer(initialState, {
  [constants.NOTIFICATION_COUNT_UPDATED]: (state, payload) => ({
    ...state, count: payload.count,
  }),
});
